<template lang="pug" src="./hero-home.pug"></template>

<script>
export default {
  data () {
    return {
      options: {
        root: null,
        rootMargin: '0px',
        threshold: [0.75]
      }
    }
  },
  props: ['props'],
  methods: {
    onScroll ({going, direction}) {
      if (going === 'in' && direction === 'top') {
        this.$store.dispatch('VIEW_NAV', true)
      }
      if (going === 'in' && direction === 'bottom') {
        this.$store.dispatch('VIEW_NAV', false)
      }
    }
  }
}
</script>



// WEBPACK FOOTER //
// src/components/hero/hero-home/hero-home.vue